import {assert} from 'Asserts';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import uniqueId from 'util/uniqueId';

// Register ids in cid map, and remove id
export function addCid<T extends {id?: string | number; cid?: string}>(
  item: T,
  prefix: string,
  cidIdMap: CidIdMap
): void {
  assert(item.cid == null, 'Trying to add a cid to an item that already has one');
  assert(Object.isExtensible(item), 'Item is not extensible, this will not work', item);
  item.cid = uniqueId(prefix);
  if (item.id != null) {
    cidIdMap[item.cid] = item.id;
  } else {
    delete cidIdMap[item.cid];
  }
  delete item.id;
}
